<template>
  <sfs-form-modal
    :id="modalId"
    :title="modalTitle"
    @on-hide="resetFormData"
  >
    <compliance-document-coverages-form
      @on-submit="create"
      @on-save="onSave"
      @on-cancel="closeModal"
      :key="formKey"
      :document-type="documentType"
    />
  </sfs-form-modal>
</template>

<script>
import ComplianceDocumentCoveragesForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';
import complianceDocumentTerminology from '@/utils/complianceDocumentTerminology';

export default {
  name: 'ComplianceDocumentAddModal',
  mixins: [formModalMixin],
  components: {
    ComplianceDocumentCoveragesForm,
  },
  props: {
    complianceDocumentId: { type: Number, required: true },
    documentType: String,
  },
  data() {
    return {
      modalId: 'compliance-document-coverage-add-modal',
    };
  },
  computed: {
    terminology() {
      return complianceDocumentTerminology(this.documentType);
    },
    modalTitle() {
      return this.terminology.renewCoverageButton;
    },
  },
  methods: {
    create(data, handleCreate) {
      handleCreate(this.$complianceDocumentCoveragesAPI.create(this.complianceDocumentId, data));
    },
    onSave() {
      this.closeModal();
      this.resetFormData();
      this.$emit('on-save');
    },
  },
};
</script>
